import React, { useEffect, useState } from 'react';

export default function BaseInput({
  type,
  name,
  value,
  onChange,
  required,
  error,
  pattern,
  title,
  placeholder,
  onKeyPress,
  onBlur,
  backgroundImage,
  maxLength,
  max,
  autoComplete,
}) {
  const [className, setClassName] = useState('form-input');

  useEffect(() => {
    if (error) {
      setClassName('form-input error');
    } else {
      setClassName('form-input');
    }
  }, [error]);

  return (
    <input
      type={type}
      name={name}
      className={className}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      required={required}
      pattern={pattern}
      title={title}
      onKeyPress={onKeyPress}
      onBlur={onBlur}
      style={{ backgroundImage: backgroundImage ? `url(${backgroundImage})` : '' }}
      maxLength={maxLength}
      max={max}
      autoComplete={autoComplete}
    />
  );
}
